var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.5 5.375c.813.125 1.156 1.125.563 1.75l-3.313 3.188.781 4.53a1.024 1.024 0 0 1-1 1.188c-.156 0-.312-.062-.469-.125L9 13.75l-4.094 2.156a1.3 1.3 0 0 1-.468.094.998.998 0 0 1-1-1.156l.78-4.563L.907 7.094C.313 6.5.656 5.5 1.47 5.375l4.562-.656L8.094.563A.98.98 0 0 1 8.969 0c.375 0 .719.188.906.563l2.063 4.156zm-4.312 4.656c-.032-.156.03-.312.124-.437l2.97-2.875-4.094-.594c-.157-.031-.313-.125-.376-.281L9 2.125 7.156 5.844c-.062.156-.218.25-.375.281l-4.093.594 2.968 2.875c.094.125.157.281.125.437l-.687 4.063 3.656-1.906a.43.43 0 0 1 .469 0l3.656 1.906z"
  })));
};
export default SvgStar;